<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 24 24" fill="none" {...$$props}
  ><path
    fill="currentColor"
    d="M13.211 4.641a7.394 7.394 0 0 1 3.427 13.918l-.705-1.323a5.892 5.892 0 0 0 3.12-5.201A5.894 5.894 0 0 0 13.2 6.14l2.117 2.872h-1.75l-2.665-3.615 2.664-3.612h1.751l-2.105 2.855ZM12.033 19.358a7.394 7.394 0 0 1-3.535-13.86l.728 1.312a5.892 5.892 0 0 0-3.036 5.154 5.894 5.894 0 0 0 5.855 5.894l-2.117-2.872h1.75l2.664 3.615-2.663 3.612H9.928l2.105-2.855Z"
  /></svg
>
